import React from 'react'
import { Status, Typography } from 'shared/ui'
import { SettingsCard } from 'shared/ui/SettingsCard'
import { LINK_HELP_QUIET_HOURS } from 'shared/constants/links'
import { openQuietHoursSettings } from 'entities/QuietHours'
import styles from './styles.module.scss'

export type IQuietHoursSettingsCardProps = {
  isQuietHoursEnabled: boolean
  isQuietHoursBlockOnWeekend: boolean
  quietHoursAllowedTimeFrom: string
  quietHoursAllowedTimeTo: string
  value: boolean
  setValue: (value: boolean) => void
}

export const QuietHoursSettingsCard = ({
  isQuietHoursEnabled,
  isQuietHoursBlockOnWeekend,
  quietHoursAllowedTimeFrom,
  quietHoursAllowedTimeTo,
  value,
  setValue,
}: IQuietHoursSettingsCardProps) => {
  const handleSetValue = (status: boolean) => {
    if (status && !isQuietHoursEnabled) {
      openQuietHoursSettings()
    } else {
      setValue(status)
    }
  }

  return (
    <SettingsCard
      title={
        isQuietHoursEnabled ? (
          'Enable quiet hours'
        ) : (
          <div className={styles.title}>
            <Typography
              variant={'body-md-medium'}
              color={'var(--content-primary-primary)'}
              ariaLabel={'EnableQuietHours'}
            >
              Enable quiet hours
            </Typography>
            <Status title={'Beta'} intent={'warning'} emphasis={'high'} size={'label'} />
          </div>
        )
      }
      desc={
        isQuietHoursEnabled ? (
          <Typography
            variant={'body-md-regular'}
            color={'var(--content-primary-tertiary)'}
            ariaLabel={'EnableQuiteHours'}
          >
            Monday - {isQuietHoursBlockOnWeekend ? 'Friday' : 'Sunday'}: {quietHoursAllowedTimeFrom}{' '}
            - {quietHoursAllowedTimeTo}
            <br />
            {isQuietHoursBlockOnWeekend && <>Saturday - Sunday: Don’t send</>}
          </Typography>
        ) : (
          <Typography
            variant={'body-md-regular'}
            color={'var(--content-primary-tertiary)'}
            ariaLabel={'EnableQuiteHours'}
          >
            Delay sending messages between specific hours to avoid <br />
            contacting recipients at inappropriate times.
            <Typography
              tag={'a'}
              variant={'body-md-regular'}
              color={'var(--content-brand-primary)'}
              ariaLabel={'EnableQuiteHours'}
              className={styles.link}
              onClick={() => {
                window.open(LINK_HELP_QUIET_HOURS, '_blank', 'noreferrer')
              }}
            >
              Learn more
            </Typography>
          </Typography>
        )
      }
      value={value}
      setValue={handleSetValue}
    />
  )
}
